import { useEffect } from "react";
import { TCameraOptions } from "../../types/scanview.types";

interface UseCustomWidgetProps {
  autoSwitchActiveColor?: string;
  autoSwitchInactiveColor?: string;
  progressBarColor?: string;
  searchingBarColor?: string;
  toastBackgroundColor?: string;
  toastTextColor?: string;
  widgetBackgroundColor?: string;
  messageFontSize?: string;
  messageTextColor?: string;
  messageBackgroundColor?: string;
  cameraOptions?: TCameraOptions;
}

const useCustomWidget = ({
  autoSwitchActiveColor,
  autoSwitchInactiveColor,
  cameraOptions,
  messageBackgroundColor,
  messageFontSize,
  messageTextColor,
  progressBarColor,
  widgetBackgroundColor,
  searchingBarColor,
  toastBackgroundColor,
  toastTextColor,
}: UseCustomWidgetProps) => {
  useEffect(() => {
    if (messageFontSize) {
      document.documentElement.style.setProperty(
        "--cardscan-message-font-size",
        messageFontSize
      );
    }
    if (messageTextColor) {
      document.documentElement.style.setProperty(
        "--cardscan-message-text-color",
        messageTextColor
      );
    }
    if (messageBackgroundColor) {
      document.documentElement.style.setProperty(
        "--cardscan-message-background-color",
        messageBackgroundColor
      );
    }
    if (widgetBackgroundColor) {
      document.documentElement.style.setProperty(
        "--cardscan-widget-background-color",
        widgetBackgroundColor
      );
    }
    if (progressBarColor) {
      document.documentElement.style.setProperty(
        "--cardscan-guide-detected-color",
        progressBarColor
      );
    }
    if (autoSwitchActiveColor) {
      document.documentElement.style.setProperty(
        "--cardscan-auto-switch-active-color",
        autoSwitchActiveColor
      );
    }
    if (autoSwitchInactiveColor) {
      document.documentElement.style.setProperty(
        "--cardscan-auto-switch-inactive-color",
        autoSwitchInactiveColor
      );
    }
    if (searchingBarColor) {
      document.documentElement.style.setProperty(
        "--cardscan-guide-searching-color",
        searchingBarColor
      );
    }
    if (toastBackgroundColor) {
      document.documentElement.style.setProperty(
        "--cardscan-toast-background-color",
        toastBackgroundColor
      );
    }
    if (toastTextColor) {
      document.documentElement.style.setProperty(
        "--cardscan-toast-text-color",
        toastTextColor
      );
    }

    document.documentElement.style.setProperty(
      "--cardscan-video-flip-horizontal",
      cameraOptions?.flipHorizontal ? "scaleX(-1)" : "scaleX(1)"
    );
    document.documentElement.style.setProperty(
      "--cardscan-video-flip-vertical",
      cameraOptions?.flipVertical ? "scaleY(-1)" : "scaleY(1)"
    );
  }, [
    messageFontSize,
    messageTextColor,
    messageBackgroundColor,
    widgetBackgroundColor,
    progressBarColor,
    autoSwitchActiveColor,
    autoSwitchInactiveColor,
  ]);
};

export default useCustomWidget;
